<template>
    <div class="table-wrapper">
        <div class="table-container">
            <table class="table">
                <thead>
                    <tr>
                        <th>
                            <p class="table__title">Тип перевозки</p>
                        </th>
                        <th>
                            <p class="table__title">Ключевые параметры</p>
                        </th>
                        <th>
                            <p class="table__title">Особенности</p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <p class="table__text">FTL (Полная загрузка)</p>
                        </td>
                        <td>
                            <p class="table__text">Прямая перевозка (без промежуточных перегрузок)</p>
                        </td>
                        <td>
                            <p class="table__text">
                                Подходит для максимально быстрой и безопасной доставки целого транспортного средства под одну задачу
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p class="table__text">LTL (Сборные грузы)</p>
                        </td>
                        <td>
                            <p class="table__text">Оптимизация объёма и стоимости</p>
                        </td>
                        <td>
                            <p class="table__text">Позволяет перевозить небольшие партии груза вместе c другими, что снижает затраты</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p class="table__text">Экспресс</p>
                        </td>
                        <td>
                            <p class="table__text">Наличие специального «Экспресс-маршрута»</p>
                        </td>
                        <td>
                            <p class="table__text">Максимально быстрая доставка по выделенным скоростным направлениям</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<style scoped>
.table-wrapper {
    border-radius: 16px;
    overflow: hidden;
    margin-top: 40px;
}
.table-container {
    overflow-x: auto;
}
.table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 16px;
}
.table th,
.table td {
    padding: 26px 16px;
    text-align: left;
    vertical-align: middle;
    border-color: #E4E6E7;
    border-style: solid;
    border-width: 0 1px 1px 0;
    min-width: 426px;
}
.table thead tr:first-child th {
    border-top-width: 1px;
}
.table thead tr:first-child th:first-child {
    border-top-left-radius: 16px;
}
.table thead tr:first-child th:last-child {
    border-top-right-radius: 16px;
}
.table tbody tr:last-child td {
    border-bottom-width: 1px;
}
.table tbody tr:last-child td:first-child {
    border-bottom-left-radius: 16px;
}
.table tbody tr:last-child td:last-child {
    border-bottom-right-radius: 16px;
}
.table tr td:first-child,
.table tr th:first-child {
    border-left-width: 1px;
}
.table thead th {
    border-bottom-color: #dee2e6;
    min-width: 426px;
}
.table__title {
    font-weight: 500;
    font-style: Medium;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
}
.table__text {
    font-family: Roboto;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    margin: 0;
}
</style>